module.exports = __webpack_public_path__ + "static/img/worry-3.2529c21.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/worry-3.png
// module id = o/54
// module chunks = 1